'use strict';
/**
 *加入鼠标滚动事件指令
 *Bai.Zhiming 
 */
angular.module('ngMousewheelModule', []).
directive('ngMousewheel', ['$parse', '$rootScope', function($parse, $rootScope) {
    return {
        restrict: 'A',
        compile: function($element, attr) {
            // We expose the powerful $event object on the scope that provides access to the Window,
            // etc. that isn't protected by the fast paths in $parse.  We explicitly request better
            // checks at the cost of speed since event handler expressions are not executed as
            // frequently as regular change detection.
            var fn = $parse(attr['ngMousewheel'], /* interceptorFn */ null, /* expensiveChecks */ true);
            return function ngEventHandler(scope, element) {
                element.on('mousewheel', function(event) {
                    var callback = function() {
                        fn(scope, { $event: event });
                    };
                    scope.$apply(callback);
                });
            };
        }
    }
}]);